

import map from './map';
import templateNonModalContent from './../../../views/non-modal-content.html';



// helper funcs
 
	function groupLocations(jobs = []) {

		const jobGroups = {};

		if (jobs.length) {

			for (let i = 0; i < jobs.length; i++) {
				let job = jobs[i];

				// skip jobs with no location data
				if (!job.Location_Point) continue;

				let key = job.Location_Point.lat + job.Location_Point.lng;

				// if there's no group already, create one
				if (!jobGroups[key]) {
					jobGroups[key] = {
						Location_Point : job.Location_Point,
						locationName : job.Location && job.Location.Name || '',
						jobs : []
					};
				}

				// add job to job group
				jobGroups[key].jobs.push(job);
			}
		}

		return jobGroups;
	}


// class export 

	export function SearchMap($container = null, $mapElement = null) {

		this.googleMap = false; 
		this.markerBounds = false;
		this.gmapObjects = [];

		this.$container = $container;
		this.$mapElement = $mapElement;
	}


	SearchMap.prototype.removeAllMarkers = function() {

		for (var i = 0; i < this.gmapObjects.length; i++) {
			this.gmapObjects[i].setMap(null);
		}
        // empty markers object and array
        this.gmapObjects = [];
	}


	SearchMap.prototype.addMarkerWithLabel = function(location, map) {

		var itemLatLng = new google.maps.LatLng(
			location.Location_Point.lat, 
			location.Location_Point.lng
		);

		var markerIcon = {
			url: siteSettings.templateUri + '/assets/img/map-pin.svg',
			scaledSize: new google.maps.Size(26, 26),
			origin: new google.maps.Point(0,0),
			anchor: new google.maps.Point(13,13)
		};

		var markerLabel = location.jobs.length;

		var marker = new MarkerWithLabel({
			map: map,
			position: itemLatLng,
			// animation: google.maps.Animation.DROP,
			icon: markerIcon,
			labelContent: markerLabel,
			labelAnchor: new google.maps.Point(0, 0),
			labelClass: "gmaps-pin-pulsate", // your desired CSS class
			labelInBackground: false
		});

		// add marker to array
		this.gmapObjects.push(marker);

		// add click event
		google.maps.event.addListener(marker, 'click', () => {
			renderModal(location);

			// set map centre to pin
            // this.googleMap.setCenter(itemLatLng);
	    });

		this.markerBounds.extend(itemLatLng);

	}


	SearchMap.prototype.render = function(fields) {

		const setupMap = () => {

			if (this.googleMap) this.removeAllMarkers();

			// setup map only once
			if (!this.googleMap) {

				const mapOptions = map.defaultMapOptions();
				mapOptions.center = new google.maps.LatLng(52.2991848, 0.6177434);
				
				// create map
				this.googleMap = new google.maps.Map(this.$mapElement[0], mapOptions);

				// set centre 
				this.markerBounds = new google.maps.LatLngBounds();

				// set max zoom level
				var opt = { maxZoom: 12 };
				this.googleMap.setOptions(opt);
			}

			const apiResponse = fields.response;
			const jobs = apiResponse.data;
			const locations = groupLocations(jobs);

			for (let location in locations) {
				this.addMarkerWithLabel(locations[location], this.googleMap);
			}

			this.googleMap.fitBounds(this.markerBounds);
		}


		// do render

		if (!fields) {
			this.$container.addClass('hidden');
			return;
		}
		this.$container.removeClass('hidden');

		map.load(setupMap);		
	}



// slide out

	
	const $modal = $('.js-search-map-modal');
	const $modalClose = $modal.find('.js-search-map-modal__close');
	const $modalContent = $modal.find('.js-search-map-modal__content');

	let isOpen = false;

	(function init() {

		$('.js-search-map-modal__close').on('click', slideOut);

		$modal.on('click', function(e) {
		    e.stopPropagation();
		});

		$(document).on('click', function (e) {
			slideOut();
		});

	})();
	

	

	function slideIn() {
		if (isOpen) return false;
		$modal.show();
		$modal.addClass('non-modal--open');
		isOpen = true;
	}

	function slideOut() {
		if (!isOpen) return false;
		isOpen = false;
		$modal.removeClass('non-modal--open');
		setTimeout(function() {
			$modal.hide();
			$modalContent.html('');
		}, 200);
	}

	function renderModal(locationInformation) {

		locationInformation.number = locationInformation.jobs.length;
		locationInformation.plural = locationInformation.number === 1 ? false : true;

		const locationHTML = templateNonModalContent(locationInformation);
		$modalContent.html(locationHTML);

		slideIn();
	}

